import React from 'react';

import { useLogoutMutation } from '@/api/v1';
import { configuration } from '@/external/config';
import { keycloak } from '@/Routing/keycloak';

export const useLogout = (): VoidFunction => {
  const [logout] = useLogoutMutation();

  return React.useCallback((): void => {
    // Denylist the still-valid access token before ending the Keycloak session — logging out must
    // still complete from the user's point of view even if this call fails.
    logout()
      .unwrap()
      .catch(console.debug)
      .finally((): void => {
        keycloak
          .logout({
            redirectUri: configuration.logoutUrl,
          })
          .catch(console.debug);
      });
  }, [logout]);
};
